import { useContext, useEffect, useState } from "react";

import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";
import CustomLabel from "../../../applicationUI/CustomLabel";
import CustomButton from "../../../helperComponents/CustomButton";
import { BiCross, BiPlus } from "react-icons/bi";
import { GrClose } from "react-icons/gr";
import { FiDelete } from "react-icons/fi";
import { MdDelete, MdDeleteForever, MdDeleteOutline } from "react-icons/md";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  width: 100%;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

const SectionRow1 = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  /* justify-content: space-between; */
`;

export default function AskWorkExperience({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [workExperience, setWorkExperience] = useState([
    { companyName: "", startYear: "", endYear: "" },
  ]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser)
      if (loggedInUser.workExperience)
        setWorkExperience(loggedInUser.workExperience);
  }, []);

  let title = "Your Work Experience";

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Work Experience"
      title={title}
      onSubmit={onSubmit}
      loading={loading}
      skipID={"workExperienceOnboardingSkipped"}
    >
      <Container>
        {workExperience.map((item, index) => {
          return (
            <Section>
              <MaterialInput
                label={"Company Name"}
                value={item.companyName}
                onChange={updateField(index, "companyName")}
              />

              <MaterialInput
                label={"Role"}
                value={item.role}
                onChange={updateField(index, "role")}
              />
              <SectionRow1>
                <MaterialInput
                  type="year"
                  label={"Start Year"}
                  value={item.startYear}
                  onChange={updateField(index, "startYear")}
                />
                <MaterialInput
                  type="year"
                  label={"End Year"}
                  value={item.endYear}
                  onChange={updateField(index, "endYear")}
                />
              </SectionRow1>

              <CustomButton
                onClick={removeItem(index)}
                icon={<MdDeleteOutline />}
              />
            </Section>
          );
        })}

        <CustomButton onClick={addItem} icon={<BiPlus />}>
          Add Item
        </CustomButton>
      </Container>
    </OnboardingBoilerplate>
  );

  function updateField(fieldName, subFieldName) {
    return (e) => {
      let newData = [...workExperience];

      newData[fieldName][subFieldName] = e.target.value;

      setWorkExperience(newData);
    };
  }

  function removeItem(index) {
    return () => {
      let newData = [...workExperience];

      newData.splice(index, 1);

      setWorkExperience(newData);
    };
  }

  function addItem() {
    let newData = [...workExperience];

    newData.push({ companyName: "", startYear: "", endYear: "" });

    setWorkExperience(newData);
  }

  async function onSubmit() {
    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { workExperience },
      });
      setLoading(false);
      let newLoggedInUser = {
        ...loggedInUser,
        workExperience,
      };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
